/**
 * Format phone number for display
 * Formats phone numbers like: +1 (555) 555-5555 or (555) 555-5555
 * Based on the landing page phone formatting logic
 */
export function formatPhone(phone: string | null | undefined): string {
  if (!phone) return "-";

  // Remove all non-digit characters
  const value = phone.replace(/\D/g, '');

  if (value.length === 0) return "-";

  let formattedValue = '';

  // Handle +1 country code
  if (value.substring(0, 1) === '1' && value.length > 1) {
    // Format with +1
    if (value.length <= 4) {
      formattedValue = `+1 (${value.substring(1)}`;
    } else if (value.length <= 7) {
      formattedValue = `+1 (${value.substring(1, 4)}) ${value.substring(4)}`;
    } else {
      formattedValue = `+1 (${value.substring(1, 4)}) ${value.substring(4, 7)}-${value.substring(7, 11)}`;
    }
  } else {
    // Format without +1
    if (value.length <= 3) {
      formattedValue = `(${value}`;
    } else if (value.length <= 6) {
      formattedValue = `(${value.substring(0, 3)}) ${value.substring(3)}`;
    } else {
      formattedValue = `(${value.substring(0, 3)}) ${value.substring(3, 6)}-${value.substring(6, 10)}`;
    }
  }

  return formattedValue;
}
